import $ from 'jquery'

import colors from '../../../../../lib/colors'

export default function(o){

  var lastPos = null

  var update = function(){

    if(o.video){

      if(!div.is(':visible')){
        div.show()
      }

      var pos = o.video.currentTime

      if(pos != lastPos){      
        var length = o.video.duration
        var left = Math.round(pos / length * 400 * 100) / 100
        div.css({left: `${left}px`})
        lastPos = pos
      }

      if(o.looping && (o.loopStart || o.loopStart == 0) && pos > o.loopStart + 2){
        o.video.currentTime = o.loopStart
      }

    } else {

      if(div.is(':visible')){
        div.hide()
      }

    }

    requestAnimationFrame(update)

  }

  requestAnimationFrame(update)

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      width: '1px',
      height: '34px',
      background: colors.yellow.s_600,
      pointerEvents: 'none',
    })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/timeline/cursor/cursor.js